import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["aria-label"];
import unescapedText from 'I18n/utils/unescapedText';
import { DialogButton } from '../DialogButton/DialogButton';
import { LeftIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
export const DialogBackButton = _ref => {
  let {
      'aria-label': ariaLabel = unescapedText('ui.UIPanelNavigator.backButton')
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(DialogButton, Object.assign({
    "aria-label": ariaLabel,
    icon: LeftIcon,
    iconSize: "400"
  }, rest));
};